import {Component, OnDestroy, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {DataService} from '../services/dataService';
import {Subscription} from 'rxjs';
import {Identity, PageEnum} from '../entity';
import {environment} from '../../environments/environment';

@Component({
    selector   : 'app-main',
    templateUrl: './main.component.html',
    styleUrls  : ['./main.component.scss']
})
export class MainComponent implements OnInit, OnDestroy {
    /**
     * Is Logged ?
     */
    private _isLogin: boolean = false;
    /**
     * Identity
     */
    private _identity: Identity = null;
    /**
     * Is Logged ?
     */
    private changedIdentitySubscription: Subscription;

    /**
     * Constructor
     * @param translate
     * @param dataService
     */
    constructor(protected translate: TranslateService,
                protected dataService: DataService) {
    }


    /**
     * NgOnInit
     */
    public ngOnInit() {
        console.log('OnInit MainComponent');
        this.dataService.cleanNewPage();
        this.translate.get('mainPage.pageTitle').subscribe(
            (res: string) => {
                this.dataService.publishNewPageTitle(PageEnum.MAIN, res);
            }
        );
        this.updateInfoFromDataServive();
        this.changedIdentitySubscription = this.dataService.getChangedIdentityStream().subscribe(
            () => this.updateInfoFromDataServive()
        );
    }

    /**
     * NgOnDestroy
     */
    public ngOnDestroy() {
        console.log('OnDestroy MainComponent');
        if (this.changedIdentitySubscription != null) {
            this.changedIdentitySubscription.unsubscribe();
        }
    }

    /**
     * Update Info From Data Service
     */
    private updateInfoFromDataServive(): void {
        if (this.dataService != null) {
            this._isLogin = this.dataService.isLogged;
            this._identity = this.dataService.identity;
        }
    }

    /**
     * Get Is Login.
     */
    public get isLogin(): boolean {
        return this._isLogin;
    }

    /**
     * Get Version
     */
    public get version(): string {
        return environment.version + ' ' + environment.mode;
    }

    /**
     * Get Identity
     */
    public get identity(): Identity {
        return this._identity;
    }
}
